import {
  TWO_FA_REQUESTING,
  TWO_FA_REQUEST_SUCCESS,
  TWO_FA_POSTING,
  TWO_FA_SUCCESS,
  TWO_FA_ERROR,
} from './constants'

const initialState = {
  type: TWO_FA_REQUESTING,
  data: {},
  redirect: false,
  requesting: false,
  successful: false,
  messages: [],
  errors: [],
  postData: {},
}

const reducer = function twoFASettingReducer (state = initialState, action) {
  switch (action.type) {
    // Set the requesting flag and append a message to be shown
    case TWO_FA_REQUESTING:
      return {
        ...state, 
        type: action.type,
        redirect: false,
        requesting: true,
        successful: false,
        messages: [{ body: 'Logging in...', time: new Date() }],
        errors: [],
      }

    // Successful?  Reset the twoFASetting state.
    case TWO_FA_REQUEST_SUCCESS: 
    
      return {
        ...state, 
        type: action.type,
        data: action.data,
        errors: [],
        messages: [],
        requesting: false,
        successful: true,
      }

    // Set the requesting flag and append a message to be shown
    case TWO_FA_POSTING:
      return {
        ...state, 
        type: action.type,
        data: {},
        requesting: true,
        successful: false,
        messages: [{ body: 'posting in...', time: new Date() }],
        errors: [],
        postData: action.payload,
      }

    // Successful?  Reset the twoFASetting state.
    case TWO_FA_SUCCESS: 
      return {
        ...state, 
        type: action.type,
        errors: [],
        messages: [{ body: action.data.message, time: new Date() }],
        requesting: false,
        successful: true,
      }

    // Append the error returned from our api
    // set the success and requesting flags to false
    case TWO_FA_ERROR:
    
      return {
        ...state, 
        type: action.type,
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
        messages: [],
        requesting: false,
        successful: false,
      }

    default:
      return state
  }
}

export default reducer



// WEBPACK FOOTER //
// ./src/views/Pages/TwoFASetting/reducer.js